import React, {useEffect, useState} from "react";
import axios from "axios";
import {base, partners, projects_url, volunteers, coworker_url} from "../api";
import {Skeleton} from "primereact/skeleton";

import {FiAlertCircle} from "react-icons/fi";
import walletInfo from "../assets/images/icons/unicons/wallet-info.png";
import computer from "../assets/images/icons/unicons/computer.png";
import chartSuccess from "../assets/images/icons/unicons/chart-success.png";
import briefcase from "../assets/images/icons/unicons/briefcase.png";
import ChartBar from "./ui/elements/ChartBar";
import ChartPie from "./ui/elements/ChartPie";
import ChartLine from "./ui/elements/ChartLine";
import ChartArea from "./ui/elements/ChartArea";
import DateFunction from "./ui/elements/date";
import InfoCard from "./ui/elements/InfoCard";
import UserPerformanceComponent from "./DashboardComponents/UserPerformanceComponent";
import LatestProjectsComponent from "./DashboardComponents/LatestProjectsComponent";
import TicketsPreview from "./TicketSystem/TicketsPreview";
import {TbCreditCard, TbUsers, TbCalendar, TbSettings} from "react-icons/tb";
import PartnersSummeryComponent from "./DashboardComponents/PartnersSummeryComponent";
import {TbAtom2} from "react-icons/tb";
import BigInfoCard from "./ui/elements/BigInfoCard";
import {FaHospitalUser} from "react-icons/fa";
import {FaUserCheck} from "react-icons/fa6";
import {FaUserGroup} from "react-icons/fa6";

export default function MainPageDashboard(props) {
	const [partnersData, setPartnersData] = useState([]);
	const [partnersCount, setPartnersCount] = useState([]);
	const [projectsData, setProjectsData] = useState([]);
	const [volunteersData, setVolunteersData] = useState([]);
	const [coworkersData, setCoworkersData] = useState([]);

	useEffect(() => {
		Promise.all([
			axios.get(base + partners),
			axios.get(base + projects_url),
			axios.get(base + volunteers),
			axios.get(base + coworker_url),
		])
			.then(([partnersRes, projectsRes, volunteersRes, coworkersRes]) => {
				setPartnersData(partnersRes.data);
				setPartnersCount(partnersRes.data.length);
				setProjectsData(projectsRes.data);
				setVolunteersData(volunteersRes.data);
				setCoworkersData(coworkersRes.data);
			})
			.catch(err => {
				console.error("Error fetching dashboard data:", err);
			});
	}, []);

	console.log(partnersData);

	return (
		<div className="container-fluid p-0">
			<div className="row mb-3 match-height p-0">
				<div className="col-xl-7 col-lg-12 col-md-12 col-12">
					<DateFunction profile={props.profile} />
				</div>
				<div className="col-xl-5 col-lg-12 col-md-12 col-12 stretch-card ">
					<BigInfoCard
						title={"Գործընկերներ"}
						digits={partnersCount + " անձ"}
						percent={"+40.22%"}
						color={"text-bg-success"}
						icon={<FaHospitalUser />}
					/>

					<BigInfoCard
						title={"Աշխատակիցներ"}
						digits={coworkersData?.length + " անձ"}
						percent={"+40.22%"}
						color={"text-bg-warning"}
						icon={<FaUserGroup />}
					/>
					<BigInfoCard
						title={"Կամավորներ"}
						digits={volunteersData?.length + " անձ"}
						percent={"+40.22%"}
						color={"text-bg-info"}
						icon={<FaUserCheck />}
					/>
				</div>
			</div>

			<div className="row mb-3 match-height p-0">
				<div className="col-12 stretch-card ">
					<div className="card w-100 b-radius b-shadow p-0">
						<div className="px-4 py-3 h6 border-bottom align-items-center text-uppercase">
							<FiAlertCircle className="me-3" /> Budget chart
						</div>
						<ChartArea />
					</div>
				</div>
			</div>
			{/* <div className="row mb-3 match-height p-0">
				<InfoCard
					image={walletInfo}
					title={"Բյուջե"}
					digits={"$12,679,930"}
					percent={"+40.22%"}
					color={"text-bg-success"}
					icon={<TbCreditCard />}
				/>
				<InfoCard
					image={computer}
					title={"Նախագծեր"}
					digits={"108"}
					percent={"+18.42%"}
					color={"text-bg-info"}
					icon={<TbUsers />}
				/>
				<InfoCard
					image={chartSuccess}
					title={"Այլ"}
					digits={"$4,679"}
					percent={" +28.42%"}
					color={"text-bg-warning"}
					icon={<TbCalendar />}
				/>
				<InfoCard
					image={briefcase}
					title={"ԳՈՐԾԸՆԿԵՐՆԵՐ"}
					digits={partnersData.length}
					percent={"անձ"}
					color={"text-bg-danger"}
					icon={<TbSettings />}
				/>
			</div> */}

			<div className="row mb-3 match-height p-0">
				<div className="col-lg-8 col-md-12 col-12 stretch-card ">
					<div className="card w-100 b-radius b-shadow p-4">
						<div className="px-4 py-3 h6 border-bottom align-items-center text-uppercase">
							<FiAlertCircle className="me-3" /> Budget chart
						</div>
						<ChartLine />
					</div>
				</div>

				<div className="col-xl-4 col-lg-12 col-md-12 col-12 stretch-card">
					<PartnersSummeryComponent />
				</div>
			</div>

			<div className="row mb-3 match-height p-0">
				<div className="col-xl-4 col-lg-12 col-md-12 col-12 stretch-card ">
					<LatestProjectsComponent />
				</div>

				<div className="col-xl-4 col-lg-12 col-md-12 col-12 stretch-card">
					<PartnersSummeryComponent />
				</div>

				<div className="col-xl-4 col-lg-12 col-md-12 col-12 stretch-card">
					<div className="card w-100 b-radius b-shadow p-0">
						<div className="card-body text-bg-light w-100">
							<div className="d-flex align-items-center opacity-50">
								<TbAtom2 className="display-6  me-3 m-0" />
								<div className="m-0">
									<h5 className=" m-0">Summery</h5>
								</div>
							</div>
						</div>
						<ChartPie />
					</div>
				</div>
			</div>

			<div className="row mb-3 match-height p-0">
				<div className="col-xl-6 col-lg-12 col-md-12 col-12 stretch-card ">
					<div className="row">
						{/* <div className="col-12 mt-3">
							<div className="card w-100 b-radius b-shadow stretch-card border-0">
								<div className="px-4 py-3 h6 border-bottom align-items-center text-uppercase">
									<FiAlertCircle className="me-3" /> Budget chart
								</div>
								<ChartBar />
							</div>
						</div> */}
					</div>
				</div>
			</div>
		</div>
	);
}
